export const irritantRhinitisEnum = {
  header:'Irritant (Non- Allergic, Vasomotor) Rhinitis',
  question:
    "Did symptoms start after exposure to a physical or chemical irritant(s)? Select all that apply",
  subquestion: null,
  options: [
    {
      value: "chemicalIrritants",
      header: "Chemical irritants or odours",
      subHeader: null,
    },
    {
      value: "changesInTemperature",
      header: "A change in temperature or humidity",
      subHeader: null,
    },
    { value: "exercise", header: "Exercise", subHeader: null },
    { value: "none", header: "None", subHeader: null },
  ],
  customInput: {
    name: "irritantRhinitisComments",
    type: "textarea",
    label: "Identify Irritant (and avoid if possible)",
    placeholder: "Comments (Optional)",
  },
};


export const occupationalRhinitisEnum = {
  header:'Occupational Rhinitis',
  question:
    "Were symptoms caused by an irritant or allergen in the work place?",
  subquestion: null,
  options: [
    {
      value: "Yes",
      header: "Yes",
      subHeader: null,
    },
    {
      value: "No",
      header: "No",
      subHeader: null,
    },
    {
      value: "Does not apply",
      header: "Not Applicable",
      subHeader: null,
    },
  ],
};

export const highRiskProfessionEnum = {
  header: "Occupational Rhinitis",
  question: "Do you work in a high risk profession?",
  subquestion: "Select all that apply.",
  options: [
    {
      value: 'farmer',
      header: "Farmer",
      subHeader: null,
    },
    {
      value: 'veterinarian',
      header: "Veterinarian",
      subHeader: null,
    },
    {
      value: 'laboratoryWorker',
      header: "Laboratory Worker",
      subHeader: null,
    },
    {
      value: 'foodProcessingWorker',
      header: "Food Processing Worker",
      subHeader: null,
    },
    {
      value: 'manufacturingWorker',
      header: "Manufacturing Worker",
      subHeader: null,
    },
    {
      value: 'other',
      header: "Other",
      subHeader: null,
    },
  ],
};

export const structuralOrMechanicalConditionsEnum = {
  header:'Structural or Mechanical Conditions',
  question:
    "Do you have any of the following conditions? Select all that apply",
  subquestion: null,
  options: [
    {
      value: "deviatedNasalSeptum",
      header: "Deviated nasal septum",
      subHeader: null,
    },
    {
      value: "nasalPolyps",
      header: "Nasal polyps",
      subHeader: null,
    },
    { value: "hypertrophicTurbinates", header: "Enlarged or swollen mucosa (Hypertropic Turbinates) ", subHeader: null },
    { value: "adenoidHypertrophy", header: "Increased size of the adenoids (Adenoidal Hypertrophy)", subHeader: null },
    { value: "none", header: "None", subHeader: null }
  ],
  customInput: {
    name: "structuralOrMechanicalConditionsComments",
    type: "textarea",
    label: "Comments",
    placeholder: "Comments (Optional)",
  },
};


export const systemicConditionsEnum = {
  header:'Systemic Conditions',
  question:
    "Do you have any of the following conditions? Select all that apply",
  subquestion: null,
  options: [
    {
      value: "primaryDefectsInMucus",
      header: "Primary Defects in Mucus",
      subHeader: "e.g., cystic fibrosis",
    },
    {
      value: "primaryCiliaryDyskinesia",
      header: "Primary Ciliary Dyskinesia",
      subHeader: "e.g., Kartagener's Syndrome",
    },
    { value: "granulomatousDisease", header: "Granulomatous disease", subHeader: "e.g., Wegener's Granulomatousis, Sarcoidosis" },
    { value: "none", header: "None", subHeader: null }
  ],
  customInput: {
    name: "systemicConditionsComments	",
    type: "textarea",
    label: "Comments",
    placeholder: "Comments (Optional)",
  },
};